<template>
	<div class="tools" :class="isPhone == 'true' ? 'mobile' : ''">
		<div class="contact-us">
			<div class="trans-box"></div>
			<img src="@comm/images/document-conversion/homeSVG/icon_kf.svg" alt="" />
			<p>联系我们</p>
			<div class="main" :class="{ show: callUs }" @mouseleave="outPoint">
				<div class="box">
					<div class="item">
						<img src="@comm/images/document-conversion/homeSVG/icon_tel.svg" alt="" />
						<div class="fonts">
							<h4>客服电话</h4>
							<h5>400-677-5005</h5>
						</div>
					</div>
					<div class="item">
						<img src="@comm/images/document-conversion/homeSVG/icon_mail.svg" alt="" />
						<div class="fonts">
							<h4>电子邮箱</h4>
							<h5>wps@wps.cn</h5>
						</div>
					</div>
					<div class="item">
						<img src="@comm/images/document-conversion/homeSVG/icon_qq.svg" alt="" />
						<div class="fonts">
							<h4>加入数科OFD交流群</h4>
							<h5>946014825</h5>
							<div class="addTobtn">
								<span @click="joinBtn">进群咨询</span>
								<span class="right" @click="copyBtn('946014825')">复制群号</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-backtop target="#app" :bottom="354" :visibility-height="400" :right="20">
			<img src="@comm/images/document-conversion/homeSVG/icon_top.png" alt="" />
		</el-backtop>
	</div>
</template>

<script>
import { copyText } from "@comm/utils/tools";
export default {
	name: "customerService",
	props: {
		callUs: false
	},
	data() {
		return {
			isPhone: ""
		};
	},
	created() {
		this.isPhone = localStorage.getItem("isPhone");
	},
	methods: {
		joinBtn() {
			window.open("https://jq.qq.com/?_wv=1027&k=buqIcKXH");
		},
		//复制
		copyBtn(data) {
			copyText(data)
			// let oInput = document.createElement("input");
			// oInput.value = data;
			// document.body.appendChild(oInput);
			// oInput.select(); // 选择对象;
			// document.execCommand("Copy"); // 执行浏览器复制命令
			// this.$message({
			// 	message: "复制成功",
			// 	type: "success"
			// });
			// document.body.removeChild(oInput);
		},
		outPoint() {
			this.$emit("callUs", false);
		}
	}
};
</script>

<style lang="scss" scoped>
.el-backtop {
	width: 48px;
	height: 48px;
	box-shadow: -2px 0px 6px 0px rgba(244, 241, 241, 0.28);
	border-radius: 4px 0px 0px 4px;
	img {
		width: 24px;
		height: 24px;
	}
	&.mobile {
		bottom: 65%;
	}
}
.tools {
	position: fixed;
	right: 20px;
	bottom: 410px;
	z-index: 991;
	&.mobile {
		bottom: 67%;
	}
	.contact-us {
		width: 48px;
		height: 82px;
		background: #14a8f0;
		box-shadow: -2px 0px 6px 0px rgba(244, 241, 241, 0.28);
		border-radius: 4px 0px 0px 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		.trans-box {
			position: absolute;
			top: 0;
			right: 48px;
			width: 8px;
			height: 82px;
			background-color: #fff;
			opacity: 0;
		}
		&:hover {
			cursor: pointer;
			.main {
				display: block;
				cursor: default;
			}
		}
		img {
			width: 24px;
			height: 24px;
			margin-bottom: 8px;
		}
		p {
			font-size: 12px;
			color: #ffffff;
			line-height: 17px;
			width: 24px;
			margin: 0;
		}
		.main {
			width: 200px;
			position: absolute;
			left: -208px;
			top: 0;
			// padding-right: 8px;
			display: none;
			&.show {
				display: block;
			}
			.box {
				width: 100%;
				background: #ffffff;
				box-shadow: 0px 2px 4px 0px rgba(170, 170, 170, 0.16), -2px 0px 6px 0px rgba(244, 241, 241, 0.28);
				border-radius: 4px;
				padding: 16px;
				.item {
					width: 100%;
					margin-bottom: 8px;
					display: flex;
					align-items: flex-start;
					.fonts {
						flex: 1;
					}
					&:last-child {
						margin: 0;
					}
					img {
						width: 24px;
						margin-right: 8px;
					}
					h4 {
						font-size: 12px;
						font-weight: 400;
						color: #8b97af;
						line-height: 22px;
						text-shadow: 0px 2px 4px rgba(170, 170, 170, 0.16);
						margin: 0;
					}
					h5 {
						font-size: 14px;
						font-weight: 400;
						color: #242f44;
						line-height: 24px;
						text-shadow: 0px 2px 4px rgba(170, 170, 170, 0.16);
						margin: 0;
					}
					.addTobtn {
						width: 100%;
						padding: 0;
						height: 24px;
						line-height: 24px;
						cursor: pointer;
						border: 0;
						span {
							font-size: 14px;
							font-weight: 400;
							color: #15b2ff;
							line-height: 24px;
							text-shadow: 0px 2px 4px rgba(170, 170, 170, 0.16);
							text-decoration: underline;
							&.right {
								margin-left: 8px;
							}
						}
					}
				}
			}
		}
	}
	.back-to-top {
		width: 58px;
		height: 58px;
		line-height: 58px;
		text-align: center;
		cursor: pointer;
	}
}
.mobile {
	.el-backtop {
		bottom: 63% !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/customerService/index.vue